export default __webpack_public_path__ + "static/media/Staff of Devout Piety.93a16c13.jpg";